import * as React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import PrivacyPolicy from '../../../../components/home/PrivacyPolicy/PNContent'

const StyledPrivacyPolicy = styled(PrivacyPolicy)`
  padding: 1rem;
`

function MainView(props) {
  return (
    <>
      <Helmet>
        <style>
          {`.adsbygoogle {
            display: none !important;
          }`}
        </style>
      </Helmet>
      <StyledPrivacyPolicy />
    </>
  )
}

export default MainView
